var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.334V3.75A.75.75 0 0 0 2.75 3a.75.75 0 0 0-.75.75v3.5c0 .416.335.75.75.75h3.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75H4.522A6.499 6.499 0 0 1 16.5 10a6.499 6.499 0 0 1-10.084 5.422.75.75 0 0 0-.831 1.25A7.95 7.95 0 0 0 10 18a8 8 0 0 0 8-8A8 8 0 0 0 3.5 5.334M10 6a.75.75 0 0 0-.75.75V10c0 .2.078.39.22.531l2.25 2.25a.75.75 0 0 0 1.06-1.06l-2.033-2.03V6.75a.75.75 0 0 0-.75-.75z"
  })));
};
export default SvgHistory;